<template>
    <div :class="{ 'flex justify-end': justifyEnd }">
        <input
            :name="name"
            :size="size"
            class="form-input text-right"
            :class="addClasses"
            ref="input"
            v-bind:value="value"
            v-on:input="updateValue($event.target.value)"
            v-on:focus="selectAll"
            v-on:blur="formatValue">
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: ''
            },

            size: {
                type: Number,
                default: 10
            },

            addClasses: {
                type: String,
                required: false
            },

            justifyEnd: {
                type: Boolean,
                default: false
            },

            value: {
                type: [Number, String],
                default: 0
            },
        },

        mounted: function () {
            this.formatValue();
        },

        methods: {
            format: function (value) {
                const raw = value.toString().replace(/[^\d.]/g, '');
                return raw == '' ? '' : raw + '%';
            },

            updateValue: function (value) {
                const result = this.format(value);

                this.$refs.input.value = result
                
                this.$emit('input', result)
            },

            formatValue: function () {
                this.$refs.input.value = this.format(this.value)
            },

            selectAll: function (event) {
                setTimeout(function () {
                    event.target.select()
                }, 0)
            }
        }
    }
</script>